export const translations = {
  ru: {
    // Auth page
    title: 'Запись на прием',
    subtitle: 'Введите ИИН',
    iinPlaceholder: 'ИИН',
    continueButton: 'Продолжить',
    errorMessage: 'Произошла ошибка при получении токена',
    requiredField: 'Обязательное поле',
    iinLengthError: 'ИИН должен содержать 12 цифр',
    authBrandHeading: 'Запись на приём',
    authBrandSub: 'Быстрая запись к специалистам\nбез очереди, в любое время.',
    authBrandFeature1: 'Выбор удобного времени и даты',
    authBrandFeature2: 'Запись без регистрации — только ИИН',
    authBrandFeature3: 'Безопасная обработка данных',
    authCardDesc: 'Введите ваш ИИН для получения доступа к записи на приём.',
    authIinHint: '12 цифр без пробелов и дефисов',
    authPrivacyText: 'Нажимая «Продолжить», вы соглашаетесь с',
    
    // Service page
    serviceTitle: 'Выбор услуги',
    serviceInstruction: 'Для записи на прием выберите услугу',
    serviceSearchPlaceholder: 'Поиск по услуге',
    paymentMethodTitle: 'Способ оплаты',
    paidServices: 'Платно',
    freeServices: 'По страховке (ОСМС)',

    // AI helper
    aiHelperTitle: 'Не знаете, к какому врачу обратиться?',
    aiHelperSubtitle: 'Опишите кратко свои симптомы — мы подберем подходящую услугу.',
    aiHelperPlaceholder: 'Например: сильная головная боль третий день, температура 38, шум в ушах',
    aiHelperButton: 'Подобрать услугу',
    aiHelperLoading: 'Подбираем подходящую услугу...',
    aiHelperResultTitle: 'Рекомендуемые услуги',
    aiHelperNoMatch: 'Не удалось подобрать подходящую услугу. Попробуйте описать симптомы подробнее или воспользуйтесь поиском.',
    aiHelperUrgent: 'Внимание: возможна неотложная ситуация',
    aiHelperDisclaimer: 'Подсказка носит информационный характер и не заменяет консультацию врача.',
    aiHelperError: 'Не удалось получить рекомендацию. Попробуйте позже.',
    aiHelperUnavailable: 'Сервис рекомендаций временно недоступен.',
    aiHelperBadge: 'Рекомендуется',
    aiHelperClear: 'Сбросить',

    osmsTitle: 'Для записи по ГОБМП/ОСМС',
    osmsMessage: 'Просим позвонить по указанным ниже номерам или оставить заявку, и оператор перезвонит вам.',
    
    // Doctor page
    doctorTitle: 'Выбор врача',
    doctorSearchPlaceholder: 'Поиск по ФИО',
    
    // Doctor card
    reviews: 'Отзывы',
    reviewsCount: 'отзывов',
    noReviews: 'Пока нет отзывов',
    degree: 'Степень',
    about: 'О враче',
    position: 'Должность',
    cost: 'Стоимость',
    bookAppointment: 'Записаться',
    closeReviews: 'Закрыть',
    doctorReviews: 'Отзывы о враче',
    doctorCopyLink: 'Скопировать ссылку',
    doctorLinkCopied: 'Ссылка на врача скопирована',

    // Form page
    formTitle: 'Запись',
    selectedService: 'Выбранная услуга',
    selectedDoctor: 'Выбранный врач',
    doctorType: 'Тип врача',
    experience: 'Стоимость услуги',
    appointmentDateTime: 'Дата и время приема',
    appointmentDateTimePlaceholder: 'Дата и время приема',
    yourIIN: 'Ваш ИИН',
    fullName: 'ФИО (кто придет на прием)',
    fullNamePlaceholder: 'ФИО (кто придет на прием)',
    phoneHint: 'Введите номер телефона',
    phonePlaceholder: '+7 (___) ___ __-__',
    privacyPolicy: 'политику конфиденциальности',
    privacyAgreement: 'Я принимаю политику конфиденциальности и даю согласие на обработку моих персональных данных',
    smsAgreement: 'Подтверждаю свое согласие на отправку смс и e-mail уведомлений',
    directionAgreement: 'Подтверждаю что для записи по ГОБМП/ОСМС необходимо иметь направление',
    
    // Schedule page
    scheduleTitle: 'Спасибо за запись!',
    scheduleSubtitle: 'Ваш приём успешно зарегистрирован.',
    doctor: 'Врач:',
    service: 'Услуга:',
    dateTime: 'Дата и время:',
    callMessage: 'Ожидайте звонка для подтверждения записи.',
    missingInfo: 'Информация о записи отсутствует',
    ratingTitle: 'Оцените удобство онлайн-записи',
    ratingSubtitle: 'Пожалуйста, оцените, насколько удобно было записаться на приём.',
    ratingCommentPlaceholder: 'Комментарий (необязательно)',
    ratingSubmit: 'Отправить отзыв',
    ratingThanksTitle: 'Спасибо за вашу оценку!',
    ratingThanksSubtitle: 'Ваш отзыв помогает нам становиться лучше.',
    
    // Navigation
    step1: 'Выбор услуги',
    step2: 'Выбор врача',
    step3: 'Запись',
    
    // Policy page
    policyTitle: 'Политика конфиденциальности',
    backButton: '← Назад',
    back: 'Назад',
    generalProvisions: '1. Общие положения',
    dataCollection: '2. Сбор персональных данных',
    dataPurpose: '3. Цель обработки персональных данных',
    legalBasis: '4. Правовые основания обработки',
    dataRetention: '5. Сроки хранения данных',
    dataSecurity: '6. Безопасность данных',
    dataSharing: '7. Передача данных третьим лицам',
    yourRights: '8. Ваши права',
    policyChanges: '9. Изменения в Политике',
    lastUpdated: 'Дата последнего обновления:',
    documentSubtitle: 'University Medical Center',
    version: 'Версия',
    
    // Policy content translations
    scopeOfApplication: '1.1. Область применения',
    policyDefinition: 'Настоящая Политика конфиденциальности (далее — «Политика») определяет порядок обработки персональных данных пользователей системы онлайн-записи на прием к врачам UMC (далее — «Система», «Сервис»).',
    acceptanceOfTerms: '1.2. Принятие условий',
    acceptanceText: 'Используя Систему, вы соглашаетесь с условиями настоящей Политики. Если вы не согласны с какими-либо условиями, пожалуйста, не используйте Систему.',
    dataCategories: '2.1. Категории собираемых данных',
    weCollect: 'Мы собираем следующие персональные данные:',
    iinDescription: 'Индивидуальный идентификационный номер (ИИН) — используется для идентификации пользователя в системе',
    nameDescription: 'Имя и фамилия — для персонализации услуг и связи с пациентом',
    phoneDescription: 'Номер телефона — для отправки уведомлений и подтверждений',
    medicalInfoDescription: 'Информация о медицинских услугах — данные о выбранных услугах и врачах',
    appointmentDataDescription: 'Данные о записях на прием — время, дата и детали запланированных визитов',
    processingPurposes: '3.1. Основные цели обработки',
    personalDataProcessed: 'Персональные данные обрабатываются для следующих целей:',
    systemOperation: 'Обеспечение работы системы — поддержка функциональности онлайн-записи',
    appointmentManagement: 'Управление записями — создание и управление записями на прием',
    notifications: 'Уведомления — отправка SMS и email уведомлений',
    serviceImprovement: 'Улучшение сервиса — анализ и улучшение качества услуг',
    legalCompliance: 'Соблюдение законодательства — выполнение требований закона',
    processingBasis: '4.1. Основания для обработки',
    processingBasisText: 'Обработка персональных данных осуществляется на основании:',
    subjectConsent: 'Согласие субъекта — ваше явное согласие на обработку персональных данных',
    contractExecution: 'Исполнение договора — необходимость для оказания медицинских услуг',
    legalRequirements: 'Законодательные требования — соблюдение законов Республики Казахстан',
    retentionPeriods: '5.1. Периоды хранения',
    retentionText: 'Персональные данные хранятся в течение срока, необходимого для достижения целей обработки, а также в течение сроков, установленных законодательством Республики Казахстан.',
    activeRecords: 'Активные записи — хранятся до завершения курса лечения',
    treatmentHistory: 'История обращений — хранится в соответствии с медицинскими стандартами',
    userAccount: 'Аккаунт пользователя — хранится до отзыва согласия или удаления',
    securityMeasures: '6.1. Меры безопасности',
    securityText: 'Мы применяем необходимые технические и организационные меры для защиты персональных данных от несанкционированного доступа, изменения, раскрытия или уничтожения.',
    appliedMeasures: 'Применяемые меры безопасности включают:',
    dataEncryption: 'Шифрование данных при передаче и хранении',
    accessControl: 'Контроль доступа к персональным данным',
    securityMonitoring: 'Постоянный мониторинг безопасности',
    systemUpdates: 'Обновление систем защиты',
    staffTraining: 'Обучение сотрудников вопросам безопасности',
    transferConditions: '7.1. Условия передачи',
    transferText: 'Персональные данные могут передаваться третьим лицам только в случаях, предусмотренных законодательством, или с вашего явного согласия.',
    medicalInstitutions: 'Медицинские учреждения — только при необходимости оказания медицинской помощи',
    governmentBodies: 'Государственные органы — в случаях, предусмотренных законодательством',
    otherCases: 'Другие случаи — только с вашего явного согласия',
    dataSubjectRights: '8.1. Ваши права как субъекта данных',
    youHaveRight: 'Вы имеете следующие права:',
    rightToInfo: 'Право на получение информации — получение информации об обработке ваших персональных данных',
    rightToCorrection: 'Право на исправление — требование уточнения, блокирования или удаления данных',
    rightToWithdraw: 'Право на отзыв — отзыв согласия на обработку данных',
    rightToAppeal: 'Право на обжалование — обращение в уполномоченный орган по защите персональных данных',
    changesProcedure: '9.1. Порядок внесения изменений',
    changesText: 'Мы оставляем за собой право вносить изменения в настоящую Политику. Об изменениях уведомляется через Систему или по электронной почте.',
    whenMakingChanges: 'При внесении изменений:',
    usersReceiveNotifications: 'Пользователи получают уведомления об изменениях',
    effectiveDateIndicated: 'Указывается дата вступления изменений в силу',
    continuedUseMeansAgreement: 'Продолжение использования означает согласие с новыми условиями',
    
    // Error messages
    appointmentError: 'Ошибка при создании записи',
    unknownError: 'Неизвестная ошибка',
    alreadyBookedWarning: 'Предупреждение',
    alreadyBookedTitle: 'Вы уже записаны в это отделение на текущую неделю',
    alreadyBookedMessage: 'Попробуйте, пожалуйста, записаться на следующую — система позволяет только одну запись в неделю',
    
    // Common
    kzt: 'KZT',
    tenge: '₸',
    okButton: 'ОК',
    fromPrice: 'от',
    goToServiceSelection: 'Перейти к выбору услуги',
    userDataError: 'Ошибка: данные пользователя не найдены',
    formDoctorLoadError: 'Не удалось загрузить данные врача',

    // Common buttons
    saveButton: 'Сохранить',
    cancelButton: 'Отмена',
    deleteButton: 'Удалить',
    addButton: 'Добавить',
    editButton: 'Редактировать',
    resetButton: 'Сбросить',

    // Form placeholders (вынесены из инлайн-тернарников Form.tsx)
    formServicePlaceholder: 'Выберите услугу',
    formDoctorPlaceholder: 'Выберите специалиста',
    formTimePlaceholder: 'Выберите время',
    formNoTimeAvailable: 'Нет свободного времени, выберите другого специалиста',

    // Admin layout / sidebar
    adminPanelTitle: 'Админ панель UMC',
    adminLogout: 'Выйти',
    adminNavServices: 'Управление услугами',
    adminNavUploadHistory: 'История загрузок услуг',
    adminNavClients: 'Клиенты и записи',
    adminNavSpecialists: 'Специалисты',
    adminNavStatistics: 'Статистика',
    adminNavSettings: 'Настройки',
    adminNavRatings: 'Оценки записи',
    adminRatingsTitle: 'Оценки удобства онлайн-записи',
    adminRatingsSubtitle: 'Как пациенты оценивают удобство записи на приём',
    adminRatingsRefresh: 'Обновить',
    adminRatingsEmpty: 'Пока нет оценок',
    adminRatingsLoadError: 'Не удалось загрузить оценки',
    adminRatingsAverage: 'Средняя оценка',
    adminRatingsTotal: 'Всего оценок',
    adminRatingsColDate: 'Дата',
    adminRatingsColRating: 'Оценка',
    adminRatingsColDoctor: 'Врач (ID)',
    adminRatingsColService: 'Услуга',
    adminRatingsColIin: 'ИИН',

    adminUploadHistoryTitle: 'История загрузок услуг',
    adminUploadHistorySubtitle: 'Журнал всех загрузок Excel: кто, когда и с каким результатом обновлял справочник услуг.',
    adminUploadHistoryRefresh: 'Обновить',
    adminUploadHistoryDate: 'Дата',
    adminUploadHistoryUser: 'Пользователь',
    adminUploadHistoryFile: 'Файл',
    adminUploadHistorySize: 'Размер',
    adminUploadHistoryStatus: 'Статус',
    adminUploadHistoryStatusSuccess: 'Успех',
    adminUploadHistoryStatusFailed: 'Ошибка',
    adminUploadHistoryTotal: 'Всего',
    adminUploadHistoryEmpty: 'История пуста',
    adminUploadHistoryLoadError: 'Не удалось загрузить историю',

    adminDashExportHeading: 'Экспорт текущего списка услуг',
    adminDashExportDescription: 'Скачать актуальный справочник услуг в формате Excel. Структура файла совпадает с форматом загрузки (3 листа: RU/KK/EN, 9 колонок), поэтому файл можно отредактировать и залить обратно.',
    adminDashExportButton: 'Скачать Excel',
    adminDashExportingButton: 'Подготовка файла...',
    adminDashExportSuccess: '✅ Файл выгружен',
    adminDashExportError: 'Не удалось выгрузить файл',

    // Admin login
    adminLoginTitle: 'Вход в систему',
    adminLoginSubtitle: 'Панель управления услугами',
    adminLoginPhonePlaceholder: '+7 (___) ___ __-__',
    adminLoginPhoneRequired: 'Введите номер телефона',
    adminLoginPhoneInvalid: 'Неверный формат телефона',
    adminLoginPassword: 'Пароль',
    adminLoginPasswordRequired: 'Введите пароль',
    adminLoginSubmit: 'Войти',
    adminLoginFooter: 'Система управления услугами UMC',
    adminLoginSuccess: 'Успешный вход в систему',
    adminLoginErrorGeneric: 'Ошибка входа',
    adminLoginErrorServer: 'Ошибка подключения к серверу',

    // Admin dashboard (Excel upload)
    adminDashTitle: 'Управление услугами',
    adminDashSubtitle: 'Загрузите Excel файл для полного обновления списка услуг в базе данных. Все существующие данные будут удалены и заменены новыми.',
    adminDashUploadHeading: 'Загрузка и обновление услуг',
    adminDashSelectFile: 'Выберите Excel файл',
    adminDashSupportedFormats: 'Поддерживаемые форматы: .xlsx, .xls',
    adminDashMaxFileSize: 'Максимальный размер файла: 10MB',
    adminDashFileStructureTitle: 'Структура многоязычного Excel файла:',
    adminDashFileStructureSheets: 'Файл должен содержать 3 листа (страницы):',
    adminDashSheet1: 'Лист 1: Русский язык',
    adminDashSheet2: 'Лист 2: Казахский язык',
    adminDashSheet3: 'Лист 3: Английский язык',
    adminDashColumnStructure: 'Структура колонок для каждого листа:',
    adminDashColumnsAC: 'A: ID | B: ID подразделения | C: Название подразделения',
    adminDashColumnsDF: 'D: ID врача | E: ФИО врача | F: ID услуги',
    adminDashColumnsGI: 'G: Название услуги | H: Тип оплаты | I: Цена',
    adminDashUploadButton: 'Загрузить и обновить все услуги',
    adminDashUploadingButton: 'Обновление...',
    adminDashErrorExcelOnly: '❌ Ошибка: Можно загружать только Excel файлы (.xlsx, .xls)!',
    adminDashErrorSize: '❌ Ошибка: Файл должен быть меньше 10MB!',
    adminDashErrorSelect: '❌ Пожалуйста, выберите Excel файл для загрузки',
    adminDashSuccessHeader: '✅ Файл успешно обработан!',
    adminDashSuccessUpdated: 'Обновлено',
    adminDashSuccessUpdatedSuffix: 'услуг.',
    adminDashSuccessRu: '• Русский язык:',
    adminDashSuccessKk: '• Казахский язык:',
    adminDashSuccessEn: '• Английский язык:',
    adminDashSuccessRecordsWord: 'записей',
    adminDashErrorUpload: 'Ошибка при загрузке файла',

    // Statistics dashboard
    statsTitle: 'Статистика системы',
    statsEventFilter: 'Тип события',
    statsEventIin: 'Попытки ввода ИИН',
    statsEventAuthSuccess: 'Успешные входы',
    statsEventApptCreated: 'Созданные записи',
    statsEventServices: 'Выбранные услуги',
    statsEventDoctors: 'Выбранные врачи',
    statsExportButton: 'Экспорт CSV',
    statsExportSuccess: 'Данные экспортированы успешно',
    statsExportError: 'Ошибка экспорта данных',
    statsErrorLoad: 'Ошибка загрузки статистики',
    statsErrorLoadDaily: 'Ошибка загрузки дневной статистики',
    statsErrorLoadHourly: 'Ошибка загрузки почасовой статистики',
    statsCardIinAttempts: 'Попытки ввода ИИН',
    statsCardAuthSuccess: 'Успешные входы',
    statsCardApptCreated: 'Созданные записи',
    statsCardUnique: 'Уникальные пользователи',
    statsTabDaily: 'Дневная статистика',
    statsTabHourly: 'Почасовая статистика',
    statsTabPopular: 'Популярные услуги',
    statsTabLangs: 'Распределение по языкам',
    statsDailyTitle: 'Таблица дневной статистики',
    statsHourlyTitle: 'Таблица почасовой статистики',
    statsHourlySelectDate: 'Выберите дату',
    statsPopularServicesTitle: 'Популярные услуги',
    statsLangDistributionTitle: 'Распределение по языкам',
    statsColDate: 'Дата',
    statsColEventType: 'Тип события',
    statsColCount: 'Количество',
    statsColUnique: 'Уникальные пользователи',
    statsColHour: 'Час',
    statsColService: 'Услуга',
    statsColLang: 'Язык',
    statsColPercent: 'Процент',

    // Clients analytics
    clientsTitle: 'Аналитика клиентов и записей',
    clientsErrorLoad: 'Ошибка загрузки данных',
    clientsStatTotal: 'Всего клиентов',
    clientsStatBooked: 'Записались',
    clientsStatIinOnly: 'Только ИИН',
    clientsStatConversion: 'Конверсия',
    clientsStatTotalAppts: 'Всего записей',
    clientsStatLast30: 'За последние 30 дней',
    clientsStatPopDoctors: 'Популярных врачей',
    clientsStatPopServices: 'Популярных услуг',
    clientsTabClients: 'Клиенты',
    clientsTabAppointments: 'Записи',
    clientsTabPopDoctors: 'Популярные врачи',
    clientsTabPopServices: 'Популярные услуги',
    clientsStatusFilter: 'Фильтр по статусу:',
    clientsFilterAll: 'Все',
    clientsFilterIin: 'Только ИИН',
    clientsFilterBooked: 'Записались',
    clientsStatusBooked: 'Записался',
    clientsStatusIinOnly: 'Только ИИН',
    clientsColIin: 'ИИН',
    clientsColName: 'ФИО',
    clientsColPhone: 'Телефон',
    clientsColStatus: 'Статус',
    clientsColLang: 'Язык',
    clientsColCreated: 'Дата создания',
    clientsColApptId: 'ID',
    clientsColApptClient: 'Клиент',
    clientsColApptDoctor: 'Врач',
    clientsColApptService: 'Услуга',
    clientsColApptDate: 'Дата записи',
    clientsColApptCreated: 'Создано',
    clientsColDoctorId: 'ID врача',
    clientsColApptCount: 'Количество записей',
    clientsColUnique: 'Уникальных клиентов',
    clientsColServiceId: 'ID услуги',
    langLabelRu: 'Русский',
    langLabelKk: 'Қазақша',
    langLabelEn: 'English',

    // Specialists management
    specMgmtTitle: 'Специалисты',
    specMgmtSearchPlaceholder: 'Поиск: ФИО, специализация, список специализаций (RU), категория, ИИН, телефон…',
    specMgmtFilterSpecAll: 'Все специализации',
    specMgmtFilterCatAll: 'Все категории',
    specMgmtFilterCatChild: 'Детский',
    specMgmtFilterCatAdult: 'Взрослый',
    specMgmtSortRecent: 'Сначала недавно изменённые',
    specMgmtSortOldest: 'Сначала старые записи',
    specMgmtSortNameAsc: 'По ФИО (А → Я)',
    specMgmtSortNameDesc: 'По ФИО (Я → А)',
    specMgmtSortSpecAsc: 'По специализации (А → Я)',
    specMgmtSortSpecDesc: 'По специализации (Я → А)',
    specMgmtSortExpDesc: 'По стажу (сначала больше)',
    specMgmtSortExpAsc: 'По стажу (сначала меньше)',
    specMgmtImportExcel: 'Импорт Excel',
    specMgmtExportExcel: 'Экспорт Excel',
    specMgmtExportSuccess: '✅ Список специалистов выгружен',
    specMgmtExportError: 'Не удалось выгрузить список специалистов',
    specMgmtAddBtn: 'Добавить специалиста',
    specMgmtFoundLabel: 'Найдено:',
    specMgmtFoundOf: 'из',
    specMgmtTotalLabel: 'Всего:',
    specMgmtTabGeneral: 'Общее',
    specMgmtTabContacts: 'Контакты и график',
    specMgmtTabRussian: 'Русский',
    specMgmtTabKazakh: 'Қазақша',
    specMgmtTabEnglish: 'English',
    specMgmtSectionBasic: 'Основное (ТЗ 2.1)',
    specMgmtSectionBio: 'Описание и биография',
    specMgmtSectionPhoto: 'Фото',
    specMgmtSectionContacts: 'Контактная информация',
    specMgmtSectionSchedule: 'График работы',
    specMgmtFinalFio: 'Итоговое ФИО для отображения:',
    specMgmtFinalFioSource: '(из русского блока или поля ниже)',
    specMgmtFinalFioMissing: '— задайте фамилию, имя, отчество (RU) или введите ФИО вручную',
    specMgmtFullNameManual: 'ФИО (вручную, необязательно)',
    specMgmtFullNameManualHint: 'Если пусто — Фамилия, Имя, Отчество из вкладки «Русский»',
    specMgmtFullNamePh: 'Напр.: Иванов Иван Иванович',
    specMgmtBriefSpecLabel: 'Краткая специализация (внутр., необязательно)',
    specMgmtBriefSpecHint: 'Если пусто — «Специальность» (RU) или первая из «Специализация» (RU) через «,»',
    specMgmtBriefSpecPh: 'Кардиолог',
    specMgmtFieldCategory: 'Категория',
    specMgmtCategorySelect: 'Выберите категорию',
    specMgmtCategoryChild: 'Детский',
    specMgmtCategoryAdult: 'Взрослый',
    specMgmtCategoryPh: 'Детский / взрослый',
    specMgmtFieldIin: 'ИИН',
    specMgmtFieldIinHint: 'Дублируется в многоязычных настройках при необходимости — основное хранение здесь',
    specMgmtExpYears: 'Стаж (полных лет)',
    specMgmtFieldStatus: 'Статус',
    specMgmtStatusHint: 'Активен / неактивен',
    specMgmtStatusActive: 'Активен',
    specMgmtStatusInactive: 'Неактивен',
    specMgmtAboutDoctor: 'Описание (о враче)',
    specMgmtAboutDoctorPh: 'Текст для карточки врача',
    specMgmtEducation: 'Образование',
    specMgmtEducationPh: 'ВУЗ, ординатура, курсы',
    specMgmtBiography: 'Биография',
    specMgmtBiographyPh: 'Краткая профессиональная биография',
    specMgmtPhotoLoading: 'Загрузка фото',
    specMgmtPhotoLoadingPlease: 'Пожалуйста, подождите',
    specMgmtPhotoUploading: 'Идёт загрузка…',
    specMgmtPhotoUpload: 'Загрузить фото',
    specMgmtPhotoDelete: 'Удалить',
    specMgmtPhotoHint: 'JPG/PNG, до 5 МБ',
    specMgmtPhone: 'Телефон',
    specMgmtPhonePh: '+7 (777) 777-77-77',
    specMgmtEmail: 'E-mail',
    specMgmtEmailInvalid: 'Некорректный e-mail',
    specMgmtEmailPh: 'doctor@example.com',
    specMgmtAdditionalContacts: 'Дополнительные контакты',
    specMgmtSchedulePh: 'Пн-Пт: 09:00 – 18:00\nСб: 10:00 – 14:00',
    specMgmtMultiValuesHint: 'Несколько значений через запятую «,»',
    specMgmtFioRequiredAlert: 'Обязательно: укажите ФИО вручную на вкладке «Общее» либо фамилию и имя (и при необходимости отчество) ниже',
    specMgmtSpecRequiredAlert: 'Обязательно: укажите «Специальность» (RU), или «Специализация» (RU) через запятую, либо краткую специализацию на вкладке «Общее»',
    specMgmtLastName: 'Фамилия',
    specMgmtLastNameHelp: 'Вместе с именем / отчеством задаёт обязательное ФИО, если оно не введено вручную на «Общее»',
    specMgmtFirstName: 'Имя',
    specMgmtPatronymic: 'Отчество',
    specMgmtCenters: 'Центры',
    specMgmtKads: 'КАДы',
    specMgmtDepartment: 'Отдел',
    specMgmtSpecialty: 'Специальность',
    specMgmtSpecialtyHelp: 'Вместе со списком «Специализация» задаёт обязательное поле «специализация» для API',
    specMgmtSpecializations: 'Специализация',
    specMgmtSpecializationsPh: 'Напр.: терапия, кардиология',
    specMgmtLanguages: 'Владение языками',
    specMgmtLanguagesPh: 'Напр.: қазақ, орыс, ағылшын',
    specMgmtReviewsLink: 'Ссылка на отзывы по врачу',
    specMgmtReviewFormLink: 'Ссылка на форму отзыва на врача',
    specMgmtDegree: 'Степень',
    specMgmtExperience: 'Опыт работы',
    specMgmtModalEdit: 'Редактирование специалиста',
    specMgmtModalNew: 'Новый специалист',
    specMgmtErrorLoad: 'Не удалось загрузить список специалистов',
    specMgmtUpdated: 'Информация о специалисте обновлена',
    specMgmtAdded: 'Специалист успешно добавлен',
    specMgmtErrorSave: 'Не удалось сохранить специалиста',
    specMgmtPhotoFormatError: 'Поддерживаются только JPG и PNG',
    specMgmtPhotoSizeError: 'Размер фото не должен превышать {mb} МБ',
    specMgmtPhotoUploaded: 'Фотография успешно загружена',
    specMgmtPhotoUploadError: 'Не удалось загрузить фото',
    specMgmtDeleted: 'Специалист удален',
    specMgmtErrorDelete: 'Не удалось удалить специалиста',
    specMgmtExcelOnly: 'Поддерживаются только Excel файлы (.xlsx, .xls)',
    specMgmtExcelError: 'Не удалось обработать Excel файл',
    specMgmtConfirmDelete: 'Удалить специалиста?',
    specMgmtConfirmDeleteDesc: 'Это действие нельзя отменить',
    specMgmtColSpecialist: 'Специалист',
    specMgmtColCategory: 'Категория',
    specMgmtColExperience: 'Стаж',
    specMgmtYears: 'лет',
    specMgmtColContacts: 'Контакты',
    specMgmtColDepartment: 'Отдел',
    specMgmtColStatus: 'Статус',

    // Admin settings
    adminSettingsTitle: 'Настройки',
    adminSettingsShowBrackets: 'Показывать текст в скобках на странице услуг',
    adminSettingsShowBracketsExample: 'Например: "Акушер гинеколог (отд вед беремен)".',
    adminSettingsBracketsOn: 'Отображение текста в скобках включено',
    adminSettingsBracketsOff: 'Текст в скобках скрыт',

    // AdmissionDate widget
    admDateToday: 'Сегодня',
    admDateTomorrow: 'Завтра',
    admDateMorning: 'Утро',
    admDateAfternoon: 'День',
    admDateEvening: 'Вечер',
    admDateNext: 'Далее',
    admDateSelectDate: 'Выберите дату',

    // Doctor widget (вынесенные инлайн-тернарники)
    doctorTodayWord: 'сегодня',
    doctorTomorrowWord: 'завтра',
    doctorSlotTitle: 'Ближайшие свободные слоты',
    doctorNoSlots: 'Нет доступных слотов времени',
    doctorChooseTime: 'Выберите время',
    doctorBioMore: 'Подробнее',
    doctorFilteringText: 'Идет фильтрация врачей по свободным слотам...',
    doctorSearchingText: 'Идет поиск врачей',
    doctorCategoryAll: 'Все',
    doctorCategoryAdult: 'Взрослый',
    doctorCategoryChild: 'Детский',

    // Footer
    footerBrandTop: 'University',
    footerBrandMain: 'Medical Center',
    footerBrandSub: 'Наука · Образование · Здравоохранение',
    footerClinic: 'Клиника',
    footerClinicSite: 'Наш сайт',
    footerClinicAbout: 'О UMC',
    footerClinicSpecialists: 'Наши специалисты',
    footerPatients: 'Пациентам',
    footerPatientsServices: 'Услуги и стоимость',
    footerPatientsHospitalization: 'Госпитализация',
    footerPatientsReminder: 'Памятка пациентам',
    footerContacts: 'Контакты',
    footerContactsReach: 'Связаться с нами',
    footerContactsBooking: 'Запись на приём',
    footerPolicy: 'Пользовательское соглашение',
    authCopyright: 'Все права защищены.'
  },
  kk: {
    // Auth page
    title: 'Дәрігерге жазылу',
    subtitle: 'ЖСН енгізіңіз',
    iinPlaceholder: 'ЖСН',
    continueButton: 'Жалғастыру',
    errorMessage: 'Токен алу кезінде қате орын алды',
    requiredField: 'Міндетті өріс',
    iinLengthError: 'ЖСН 12 цифрдан тұруы керек',
    authBrandHeading: 'Дәрігерге жазылу',
    authBrandSub: 'Мамандарға жылдам жазылу,\nкезексіз, кез келген уақытта.',
    authBrandFeature1: 'Ыңғайлы уақыт пен күнді таңдау',
    authBrandFeature2: 'Тіркеусіз жазылу — тек ЖСН',
    authBrandFeature3: 'Деректерді қауіпсіз өңдеу',
    authCardDesc: 'Дәрігерге жазылуға қол жеткізу үшін ЖСН енгізіңіз.',
    authIinHint: '12 цифр, бос орынсыз және дефиссіз',
    authPrivacyText: '«Жалғастыру» батырмасын басу арқылы сіз',
    
    // Service page
    serviceTitle: 'Қызметті таңдау',
    serviceInstruction: 'Дәрігерге жазылу үшін қызметті таңдаңыз',
    serviceSearchPlaceholder: 'Қызмет бойынша іздеу',
    paymentMethodTitle: 'Төлем тәсілі',
    paidServices: 'Ақылы',
    freeServices: 'Сақтандыру бойынша (ОСМС)',

    // AI helper
    aiHelperTitle: 'Қай дәрігерге баруды білмейсіз бе?',
    aiHelperSubtitle: 'Симптомдарыңызды қысқаша жазыңыз — біз сәйкес қызметті ұсынамыз.',
    aiHelperPlaceholder: 'Мысалы: үшінші күн қатты бас ауырады, температура 38, құлақта шу',
    aiHelperButton: 'Қызметті таңдау',
    aiHelperLoading: 'Сәйкес қызметті іздеудеміз...',
    aiHelperResultTitle: 'Ұсынылатын қызметтер',
    aiHelperNoMatch: 'Сәйкес қызмет табылмады. Симптомдарды толығырақ сипаттап көріңіз немесе іздеуді пайдаланыңыз.',
    aiHelperUrgent: 'Назар аударыңыз: жағдай шұғыл болуы мүмкін',
    aiHelperDisclaimer: 'Бұл ұсыныс ақпараттық сипатта және дәрігер кеңесін алмастырмайды.',
    aiHelperError: 'Ұсыныс алу мүмкін болмады. Сәл кейінірек көріңіз.',
    aiHelperUnavailable: 'Ұсыныс қызметі уақытша қолжетімді емес.',
    aiHelperBadge: 'Ұсынылады',
    aiHelperClear: 'Тазалау',

    osmsTitle: 'ГОБМП/ОСМС бойынша жазылу үшін',
    osmsMessage: 'Төмендегі нөмірлерге қоңырау шалыңыз немесе өтініш қалдырыңыз, оператор сізге қайта қоңырау шалады.',
    
    // Doctor page
    doctorTitle: 'Дәрігерді таңдау',
    doctorSearchPlaceholder: 'Аты-жөні бойынша іздеу',
    
    // Doctor card
    reviews: 'Пікірлер',
    reviewsCount: 'пікір',
    noReviews: 'Әзірге пікірлер жоқ',
    degree: 'Дәреже',
    about: 'Дәрігер туралы',
    position: 'Лауазымы',
    cost: 'Құны',
    bookAppointment: 'Жазылу',
    closeReviews: 'Жабу',
    doctorReviews: 'Дәрігер туралы пікірлер',
    doctorCopyLink: 'Сілтемені көшіру',
    doctorLinkCopied: 'Дәрігер сілтемесі көшірілді',

    // Form page
    formTitle: 'Жазылу',
    selectedService: 'Таңдалған қызмет',
    selectedDoctor: 'Таңдалған дәрігер',
    doctorType: 'Дәрігер түрі',
    experience: 'Қызмет құны',
    appointmentDateTime: 'Келу күні мен уақыты',
    appointmentDateTimePlaceholder: 'Келу күні мен уақыты',
    yourIIN: 'Сіздің ЖСН',
    fullName: 'Аты-жөні (кім келеді)',
    fullNamePlaceholder: 'Аты-жөні (кім келеді)',
    phoneHint: 'Телефон нөмірін енгізіңіз',
    phonePlaceholder: '+7 (___) ___ __-__',
    privacyPolicy: 'құпиялылық саясатын',
    privacyAgreement: 'Мен құпиялылық саясатын қабылдаймын және жеке деректерімді өңдеуге келісім беремін',
    smsAgreement: 'SMS және e-mail хабарландыруларға келісім беремін',
    directionAgreement: 'ГОБМП/ОСМС бойынша жазылу үшін бағыттама қажет екенін растаймын',
    
    // Schedule page
    scheduleTitle: 'Жазылу үшін рахмет!',
    scheduleSubtitle: 'Сіздің келуіңіз сәтті тіркелді.',
    doctor: 'Дәрігер:',
    service: 'Қызмет:',
    dateTime: 'Күні мен уақыты:',
    callMessage: 'Жазылуды растау үшін қоңырау күтіңіз.',
    missingInfo: 'Жазылу туралы ақпарат жоқ',
    ratingTitle: 'Онлайн-жазылудың ыңғайлылығын бағалаңыз',
    ratingSubtitle: 'Қабылдауға жазылу қаншалықты ыңғайлы болғанын бағалаңызшы.',
    ratingCommentPlaceholder: 'Пікір (міндетті емес)',
    ratingSubmit: 'Пікір жіберу',
    ratingThanksTitle: 'Бағалағаныңызға рахмет!',
    ratingThanksSubtitle: 'Сіздің пікіріңіз бізге жақсаруға көмектеседі.',
    
    // Navigation
    step1: 'Қызметті таңдау',
    step2: 'Дәрігерді таңдау',
    step3: 'Жазылу',
    
    // Policy page
    policyTitle: 'Құпиялылық саясаты',
    backButton: '← Артқа',
    back: 'Артқа',
    generalProvisions: '1. Жалпы ережелер',
    dataCollection: '2. Жеке деректерді жинау',
    dataPurpose: '3. Жеке деректерді өңдеу мақсаты',
    legalBasis: '4. Өңдеудің құқықтық негізі',
    dataRetention: '5. Деректерді сақтау мерзімі',
    dataSecurity: '6. Деректер қауіпсіздігі',
    dataSharing: '7. Үшінші тұлғаларға деректер беру',
    yourRights: '8. Сіздің құқықтарыңыз',
    policyChanges: '9. Саясаттағы өзгерістер',
    lastUpdated: 'Соңғы жаңарту күні:',
    documentSubtitle: 'University Medical Center',
    version: 'Нұсқа',
    
    // Policy content translations
    scopeOfApplication: '1.1. Қолданыс аясы',
    policyDefinition: 'Бұл Құпиялылық саясаты (бұдан әрі — «Саясат») UMC дәрігерлеріне жазылу жүйесінің пайдаланушыларының жеке деректерін өңдеу тәртібін анықтайды (бұдан әрі — «Жүйе», «Қызмет»).',
    acceptanceOfTerms: '1.2. Шарттарды қабылдау',
    acceptanceText: 'Жүйені пайдалана отырып, сіз бұл Саясаттың шарттарымен келісесіз. Егер сіз кез келген шарттармен келіспесеңіз, жүйені пайдаланбаңыз.',
    dataCategories: '2.1. Жиналатын деректер санаттары',
    weCollect: 'Біз келесі жеке деректерді жинаймыз:',
    iinDescription: 'Жеке сәйкестендіру нөмірі (ЖСН) — жүйедегі пайдаланушыны сәйкестендіру үшін қолданылады',
    nameDescription: 'Аты-жөні — қызметтерді жекешелендіру және науқаспен байланыс үшін',
    phoneDescription: 'Телефон нөмірі — хабарландырулар мен растаулар жіберу үшін',
    medicalInfoDescription: 'Медициналық қызметтер туралы ақпарат — таңдалған қызметтер мен дәрігерлер туралы деректер',
    appointmentDataDescription: 'Жазылу туралы деректер — жоспарланған келулердің уақыты, күні және егжей-тегжейлері',
    processingPurposes: '3.1. Өңдеудің негізгі мақсаттары',
    personalDataProcessed: 'Жеке деректер келесі мақсаттар үшін өңделеді:',
    systemOperation: 'Жүйенің жұмысын қамтамасыз ету — онлайн жазылу функционалдылығын қолдау',
    appointmentManagement: 'Жазылуларды басқару — жазылуларды жасау және басқару',
    notifications: 'Хабарландырулар — SMS және email хабарландырулар жіберу',
    serviceImprovement: 'Қызметті жақсарту — талдау және қызмет сапасын жақсарту',
    legalCompliance: 'Заңнамаға сәйкестік — заң талаптарын орындау',
    processingBasis: '4.1. Өңдеу негіздері',
    processingBasisText: 'Жеке деректерді өңдеу келесі негіздерде жүзеге асырылады:',
    subjectConsent: 'Субъекттің келісімі — жеке деректерді өңдеуге сіздің анық келісіміңіз',
    contractExecution: 'Келісімшартты орындау — медициналық қызметтер көрсету қажеттілігі',
    legalRequirements: 'Заңнамалық талаптар — Қазақстан Республикасы заңдарына сәйкестік',
    retentionPeriods: '5.1. Сақтау мерзімдері',
    retentionText: 'Жеке деректер өңдеу мақсаттарына жету үшін қажетті мерзім ішінде, сондай-ақ Қазақстан Республикасы заңнамасымен белгіленген мерзімдер ішінде сақталады.',
    activeRecords: 'Белсенді жазылулар — емдеу курсы аяқталғанға дейін сақталады',
    treatmentHistory: 'Келулер тарихы — медициналық стандарттарға сәйкес сақталады',
    userAccount: 'Пайдаланушы есебі — келісімді кері алу немесе жоюға дейін сақталады',
    securityMeasures: '6.1. Қорғау шаралары',
    securityText: 'Біз жеке деректерді рұқсатсыз кіру, өзгерту, ашу немесе жоюдан қорғау үшін қажетті техникалық және ұйымдастырушылық шараларды қолданамыз.',
    appliedMeasures: 'Қолданылатын қауіпсіздік шараларына мыналар кіреді:',
    dataEncryption: 'Деректерді беру және сақтау кезінде шифрлеу',
    accessControl: 'Жеке деректерге кіруге бақылау',
    securityMonitoring: 'Қауіпсіздікті тұрақты бақылау',
    systemUpdates: 'Қорғау жүйелерін жаңарту',
    staffTraining: 'Қауіпсіздік мәселелері бойынша қызметкерлерді оқыту',
    transferConditions: '7.1. Беру шарттары',
    transferText: 'Жеке деректер тек заңнамамен көзделген жағдайларда немесе сіздің анық келісіміңізбен үшінші тұлғаларға берілуі мүмкін.',
    medicalInstitutions: 'Медициналық мекемелер — тек медициналық көмек көрсету қажеттілігі кезінде',
    governmentBodies: 'Мемлекеттік органдар — заңнамамен көзделген жағдайларда',
    otherCases: 'Басқа жағдайлар — тек сіздің анық келісіміңізбен',
    dataSubjectRights: '8.1. Деректер субъектісі ретінде сіздің құқықтарыңыз',
    youHaveRight: 'Сізде келесі құқықтар бар:',
    rightToInfo: 'Ақпарат алу құқығы — жеке деректеріңізді өңдеу туралы ақпарат алу',
    rightToCorrection: 'Түзету құқығы — деректерді нақтылау, бұғаттау немесе жоюды талап ету',
    rightToWithdraw: 'Кері алу құқығы — деректерді өңдеуге келісімді кері алу',
    rightToAppeal: 'Шағымдану құқығы — жеке деректерді қорғауға уәкілетті органға жүгіну',
    changesProcedure: '9.1. Өзгерістер енгізу тәртібі',
    changesText: 'Біз бұл Саясатқа өзгерістер енгізу құқығын өзімізде сақтаймыз. Өзгерістер туралы Жүйе арқылы немесе электронды пошта арқылы хабарланады.',
    whenMakingChanges: 'Өзгерістер енгізу кезінде:',
    usersReceiveNotifications: 'Пайдаланушылар өзгерістер туралы хабарландырулар алады',
    effectiveDateIndicated: 'Өзгерістердің күшіне ену күні көрсетіледі',
    continuedUseMeansAgreement: 'Пайдалануды жалғастыру жаңа шарттармен келісу дегенді білдіреді',
    
    // Error messages
    appointmentError: 'Жазылу жасау кезінде қате',
    unknownError: 'Белгісіз қате',
    alreadyBookedWarning: 'Ескерту',
    alreadyBookedTitle: 'Сіз бұл аптада сол бөлімге жазылғансыз',
    alreadyBookedMessage: 'Келесі аптаға жазылуға тырысыңыз — жүйе аптына бір ғана жазылуға рұқсат береді',
    
    // Common
    kzt: 'KZT',
    tenge: '₸',
    okButton: 'ОК',
    fromPrice: 'бастап',
    goToServiceSelection: 'Қызметті таңдауға өту',
    userDataError: 'Қате: пайдаланушы деректері табылмады',
    formDoctorLoadError: 'Дәрігер деректерін жүктеу мүмкін болмады',

    // Common buttons
    saveButton: 'Сақтау',
    cancelButton: 'Бас тарту',
    deleteButton: 'Жою',
    addButton: 'Қосу',
    editButton: 'Өңдеу',
    resetButton: 'Тазалау',

    // Form placeholders
    formServicePlaceholder: 'Қызметті таңдаңыз',
    formDoctorPlaceholder: 'Маманды таңдаңыз',
    formTimePlaceholder: 'Уақытты таңдаңыз',
    formNoTimeAvailable: 'Бос уақыт жоқ, басқа маманды таңдаңыз',

    // Admin layout / sidebar
    adminPanelTitle: 'UMC әкімші панелі',
    adminLogout: 'Шығу',
    adminNavServices: 'Қызметтерді басқару',
    adminNavUploadHistory: 'Қызметтерді жүктеу тарихы',
    adminNavClients: 'Клиенттер және жазылулар',
    adminNavSpecialists: 'Мамандар',
    adminNavStatistics: 'Статистика',
    adminNavSettings: 'Параметрлер',
    adminNavRatings: 'Жазылу бағалары',
    adminRatingsTitle: 'Онлайн-жазылу ыңғайлылығының бағалары',
    adminRatingsSubtitle: 'Пациенттер қабылдауға жазылу ыңғайлылығын қалай бағалайды',
    adminRatingsRefresh: 'Жаңарту',
    adminRatingsEmpty: 'Әзірге бағалар жоқ',
    adminRatingsLoadError: 'Бағаларды жүктеу мүмкін болмады',
    adminRatingsAverage: 'Орташа баға',
    adminRatingsTotal: 'Барлық бағалар',
    adminRatingsColDate: 'Күні',
    adminRatingsColRating: 'Баға',
    adminRatingsColDoctor: 'Дәрігер (ID)',
    adminRatingsColService: 'Қызмет',
    adminRatingsColIin: 'ЖСН',

    adminUploadHistoryTitle: 'Қызметтерді жүктеу тарихы',
    adminUploadHistorySubtitle: 'Барлық Excel жүктеулер журналы: кім, қашан және қандай нәтижемен қызметтер тізімін жаңартты.',
    adminUploadHistoryRefresh: 'Жаңарту',
    adminUploadHistoryDate: 'Күні',
    adminUploadHistoryUser: 'Пайдаланушы',
    adminUploadHistoryFile: 'Файл',
    adminUploadHistorySize: 'Көлемі',
    adminUploadHistoryStatus: 'Күйі',
    adminUploadHistoryStatusSuccess: 'Сәтті',
    adminUploadHistoryStatusFailed: 'Қате',
    adminUploadHistoryTotal: 'Барлығы',
    adminUploadHistoryEmpty: 'Тарих бос',
    adminUploadHistoryLoadError: 'Тарихты жүктеу мүмкін болмады',

    adminDashExportHeading: 'Қызметтердің ағымдағы тізімін экспорттау',
    adminDashExportDescription: 'Ағымдағы қызметтер каталогын Excel форматында жүктеу. Файлдың құрылымы жүктеу форматымен бірдей (3 парақ: RU/KK/EN, 9 баған), сондықтан файлды өңдеп қайта жүктеуге болады.',
    adminDashExportButton: 'Excel жүктеу',
    adminDashExportingButton: 'Файл дайындалуда...',
    adminDashExportSuccess: '✅ Файл жүктелді',
    adminDashExportError: 'Файлды жүктеу мүмкін болмады',

    // Admin login
    adminLoginTitle: 'Жүйеге кіру',
    adminLoginSubtitle: 'Қызметтерді басқару панелі',
    adminLoginPhonePlaceholder: '+7 (___) ___ __-__',
    adminLoginPhoneRequired: 'Телефон нөмірін енгізіңіз',
    adminLoginPhoneInvalid: 'Телефон форматы дұрыс емес',
    adminLoginPassword: 'Құпиясөз',
    adminLoginPasswordRequired: 'Құпиясөзді енгізіңіз',
    adminLoginSubmit: 'Кіру',
    adminLoginFooter: 'UMC қызметтерді басқару жүйесі',
    adminLoginSuccess: 'Жүйеге сәтті кірдіңіз',
    adminLoginErrorGeneric: 'Кіру қатесі',
    adminLoginErrorServer: 'Серверге қосылу қатесі',

    // Admin dashboard
    adminDashTitle: 'Қызметтерді басқару',
    adminDashSubtitle: 'Дерекқордағы қызметтер тізімін толық жаңарту үшін Excel файлын жүктеңіз. Барлық қолданыстағы деректер жойылып, жаңаларымен ауыстырылады.',
    adminDashUploadHeading: 'Қызметтерді жүктеу және жаңарту',
    adminDashSelectFile: 'Excel файлын таңдаңыз',
    adminDashSupportedFormats: 'Қолдау көрсетілетін форматтар: .xlsx, .xls',
    adminDashMaxFileSize: 'Файлдың максималды өлшемі: 10MB',
    adminDashFileStructureTitle: 'Көптілді Excel файлының құрылымы:',
    adminDashFileStructureSheets: 'Файлда 3 парақ (бет) болуы керек:',
    adminDashSheet1: '1-парақ: Орыс тілі',
    adminDashSheet2: '2-парақ: Қазақ тілі',
    adminDashSheet3: '3-парақ: Ағылшын тілі',
    adminDashColumnStructure: 'Әр парақтың бағаналар құрылымы:',
    adminDashColumnsAC: 'A: ID | B: Бөлімше ID | C: Бөлімшенің атауы',
    adminDashColumnsDF: 'D: Дәрігер ID | E: Дәрігердің аты-жөні | F: Қызмет ID',
    adminDashColumnsGI: 'G: Қызметтің атауы | H: Төлем түрі | I: Бағасы',
    adminDashUploadButton: 'Барлық қызметтерді жүктеп жаңарту',
    adminDashUploadingButton: 'Жаңартылуда...',
    adminDashErrorExcelOnly: '❌ Қате: Тек Excel файлдарын жүктеуге болады (.xlsx, .xls)!',
    adminDashErrorSize: '❌ Қате: Файл 10MB-дан аз болуы керек!',
    adminDashErrorSelect: '❌ Жүктеу үшін Excel файлын таңдаңыз',
    adminDashSuccessHeader: '✅ Файл сәтті өңделді!',
    adminDashSuccessUpdated: 'Жаңартылды',
    adminDashSuccessUpdatedSuffix: 'қызмет.',
    adminDashSuccessRu: '• Орыс тілі:',
    adminDashSuccessKk: '• Қазақ тілі:',
    adminDashSuccessEn: '• Ағылшын тілі:',
    adminDashSuccessRecordsWord: 'жазба',
    adminDashErrorUpload: 'Файлды жүктеу кезінде қате',

    // Statistics dashboard
    statsTitle: 'Жүйе статистикасы',
    statsEventFilter: 'Оқиға түрі',
    statsEventIin: 'ЖСН енгізу әрекеттері',
    statsEventAuthSuccess: 'Сәтті кірулер',
    statsEventApptCreated: 'Жасалған жазылулар',
    statsEventServices: 'Таңдалған қызметтер',
    statsEventDoctors: 'Таңдалған дәрігерлер',
    statsExportButton: 'CSV экспорты',
    statsExportSuccess: 'Деректер сәтті экспортталды',
    statsExportError: 'Деректерді экспорттау қатесі',
    statsErrorLoad: 'Статистиканы жүктеу қатесі',
    statsErrorLoadDaily: 'Күнделікті статистиканы жүктеу қатесі',
    statsErrorLoadHourly: 'Сағаттық статистиканы жүктеу қатесі',
    statsCardIinAttempts: 'ЖСН енгізу әрекеттері',
    statsCardAuthSuccess: 'Сәтті кірулер',
    statsCardApptCreated: 'Жасалған жазылулар',
    statsCardUnique: 'Бірегей пайдаланушылар',
    statsTabDaily: 'Күнделікті статистика',
    statsTabHourly: 'Сағаттық статистика',
    statsTabPopular: 'Танымал қызметтер',
    statsTabLangs: 'Тілдер бойынша бөлу',
    statsDailyTitle: 'Күнделікті статистика кестесі',
    statsHourlyTitle: 'Сағаттық статистика кестесі',
    statsHourlySelectDate: 'Күнді таңдаңыз',
    statsPopularServicesTitle: 'Танымал қызметтер',
    statsLangDistributionTitle: 'Тілдер бойынша бөлу',
    statsColDate: 'Күні',
    statsColEventType: 'Оқиға түрі',
    statsColCount: 'Саны',
    statsColUnique: 'Бірегей пайдаланушылар',
    statsColHour: 'Сағат',
    statsColService: 'Қызмет',
    statsColLang: 'Тіл',
    statsColPercent: 'Пайыз',

    // Clients analytics
    clientsTitle: 'Клиенттер мен жазылулар аналитикасы',
    clientsErrorLoad: 'Деректерді жүктеу қатесі',
    clientsStatTotal: 'Барлық клиенттер',
    clientsStatBooked: 'Жазылғандар',
    clientsStatIinOnly: 'Тек ЖСН',
    clientsStatConversion: 'Конверсия',
    clientsStatTotalAppts: 'Барлық жазылулар',
    clientsStatLast30: 'Соңғы 30 күн',
    clientsStatPopDoctors: 'Танымал дәрігерлер',
    clientsStatPopServices: 'Танымал қызметтер',
    clientsTabClients: 'Клиенттер',
    clientsTabAppointments: 'Жазылулар',
    clientsTabPopDoctors: 'Танымал дәрігерлер',
    clientsTabPopServices: 'Танымал қызметтер',
    clientsStatusFilter: 'Мәртебе бойынша сүзгі:',
    clientsFilterAll: 'Барлығы',
    clientsFilterIin: 'Тек ЖСН',
    clientsFilterBooked: 'Жазылғандар',
    clientsStatusBooked: 'Жазылды',
    clientsStatusIinOnly: 'Тек ЖСН',
    clientsColIin: 'ЖСН',
    clientsColName: 'Аты-жөні',
    clientsColPhone: 'Телефон',
    clientsColStatus: 'Мәртебе',
    clientsColLang: 'Тіл',
    clientsColCreated: 'Жасалған күні',
    clientsColApptId: 'ID',
    clientsColApptClient: 'Клиент',
    clientsColApptDoctor: 'Дәрігер',
    clientsColApptService: 'Қызмет',
    clientsColApptDate: 'Жазылу күні',
    clientsColApptCreated: 'Жасалды',
    clientsColDoctorId: 'Дәрігер ID',
    clientsColApptCount: 'Жазылулар саны',
    clientsColUnique: 'Бірегей клиенттер',
    clientsColServiceId: 'Қызмет ID',
    langLabelRu: 'Орысша',
    langLabelKk: 'Қазақша',
    langLabelEn: 'Ағылшынша',

    // Specialists management
    specMgmtTitle: 'Мамандар',
    specMgmtSearchPlaceholder: 'Іздеу: аты-жөні, мамандану, мамандану тізімі (RU), санаты, ЖСН, телефон…',
    specMgmtFilterSpecAll: 'Барлық мамандануы',
    specMgmtFilterCatAll: 'Барлық санаттар',
    specMgmtFilterCatChild: 'Балалар',
    specMgmtFilterCatAdult: 'Ересектер',
    specMgmtSortRecent: 'Алдымен жаңадан өзгертілген',
    specMgmtSortOldest: 'Алдымен ескі жазбалар',
    specMgmtSortNameAsc: 'Аты-жөні бойынша (А → Я)',
    specMgmtSortNameDesc: 'Аты-жөні бойынша (Я → А)',
    specMgmtSortSpecAsc: 'Мамандану бойынша (А → Я)',
    specMgmtSortSpecDesc: 'Мамандану бойынша (Я → А)',
    specMgmtSortExpDesc: 'Тәжірибе бойынша (көбірек)',
    specMgmtSortExpAsc: 'Тәжірибе бойынша (азырақ)',
    specMgmtImportExcel: 'Excel импорты',
    specMgmtExportExcel: 'Excel экспорты',
    specMgmtExportSuccess: '✅ Мамандар тізімі жүктелді',
    specMgmtExportError: 'Мамандар тізімін жүктеу мүмкін болмады',
    specMgmtAddBtn: 'Маман қосу',
    specMgmtFoundLabel: 'Табылды:',
    specMgmtFoundOf: '/',
    specMgmtTotalLabel: 'Барлығы:',
    specMgmtTabGeneral: 'Жалпы',
    specMgmtTabContacts: 'Байланыстар және кесте',
    specMgmtTabRussian: 'Орысша',
    specMgmtTabKazakh: 'Қазақша',
    specMgmtTabEnglish: 'Ағылшынша',
    specMgmtSectionBasic: 'Негізгі (ТЗ 2.1)',
    specMgmtSectionBio: 'Сипаттама және өмірбаяны',
    specMgmtSectionPhoto: 'Фото',
    specMgmtSectionContacts: 'Байланыс ақпараты',
    specMgmtSectionSchedule: 'Жұмыс кестесі',
    specMgmtFinalFio: 'Көрсетуге арналған соңғы аты-жөні:',
    specMgmtFinalFioSource: '(орысша блоктан немесе төмендегі өрістен)',
    specMgmtFinalFioMissing: '— тегі, аты, әкесінің атын (RU) енгізіңіз немесе аты-жөнін қолмен жазыңыз',
    specMgmtFullNameManual: 'Аты-жөні (қолмен, міндетті емес)',
    specMgmtFullNameManualHint: 'Бос болса — «Орысша» қойындысынан тегі, аты, әкесінің аты',
    specMgmtFullNamePh: 'Мысалы: Иванов Иван Иванович',
    specMgmtBriefSpecLabel: 'Қысқа мамандану (ішкі, міндетті емес)',
    specMgmtBriefSpecHint: 'Бос болса — «Мамандық» (RU) немесе «Мамандану» (RU) ішіндегі бірінші мән «,» арқылы',
    specMgmtBriefSpecPh: 'Кардиолог',
    specMgmtFieldCategory: 'Санаты',
    specMgmtCategorySelect: 'Санатты таңдаңыз',
    specMgmtCategoryChild: 'Балалар',
    specMgmtCategoryAdult: 'Ересектер',
    specMgmtCategoryPh: 'Балалар / ересектер',
    specMgmtFieldIin: 'ЖСН',
    specMgmtFieldIinHint: 'Қажет болса көптілді параметрлерде қайталанады — негізгі сақтау осы жерде',
    specMgmtExpYears: 'Тәжірибесі (толық жыл)',
    specMgmtFieldStatus: 'Мәртебе',
    specMgmtStatusHint: 'Белсенді / белсенді емес',
    specMgmtStatusActive: 'Белсенді',
    specMgmtStatusInactive: 'Белсенді емес',
    specMgmtAboutDoctor: 'Сипаттама (дәрігер туралы)',
    specMgmtAboutDoctorPh: 'Дәрігер карточкасына арналған мәтін',
    specMgmtEducation: 'Білімі',
    specMgmtEducationPh: 'Жоғары оқу орны, ординатура, курстар',
    specMgmtBiography: 'Өмірбаяны',
    specMgmtBiographyPh: 'Қысқаша кәсіби өмірбаяны',
    specMgmtPhotoLoading: 'Фото жүктелуде',
    specMgmtPhotoLoadingPlease: 'Күте тұрыңыз',
    specMgmtPhotoUploading: 'Жүктелуде…',
    specMgmtPhotoUpload: 'Фото жүктеу',
    specMgmtPhotoDelete: 'Жою',
    specMgmtPhotoHint: 'JPG/PNG, 5 МБ дейін',
    specMgmtPhone: 'Телефон',
    specMgmtPhonePh: '+7 (777) 777-77-77',
    specMgmtEmail: 'E-mail',
    specMgmtEmailInvalid: 'E-mail форматы дұрыс емес',
    specMgmtEmailPh: 'doctor@example.com',
    specMgmtAdditionalContacts: 'Қосымша байланыстар',
    specMgmtSchedulePh: 'Дс-Жм: 09:00 – 18:00\nСб: 10:00 – 14:00',
    specMgmtMultiValuesHint: 'Бірнеше мән «,» арқылы',
    specMgmtFioRequiredAlert: 'Міндетті: «Жалпы» қойындысында аты-жөнін қолмен немесе төменде тегі мен атын (және қажет болса әкесінің атын) енгізіңіз',
    specMgmtSpecRequiredAlert: 'Міндетті: «Мамандық» (RU) немесе «Мамандану» (RU) арқылы немесе «Жалпы» қойындысында қысқа мамандануды көрсетіңіз',
    specMgmtLastName: 'Тегі',
    specMgmtLastNameHelp: 'Аты / әкесінің атымен бірге, «Жалпы» қойындысында қолмен енгізілмеген болса, міндетті аты-жөнін құрайды',
    specMgmtFirstName: 'Аты',
    specMgmtPatronymic: 'Әкесінің аты',
    specMgmtCenters: 'Орталықтар',
    specMgmtKads: 'КАД',
    specMgmtDepartment: 'Бөлім',
    specMgmtSpecialty: 'Мамандық',
    specMgmtSpecialtyHelp: '«Мамандану» тізімімен бірге API үшін міндетті «мамандану» өрісін қалыптастырады',
    specMgmtSpecializations: 'Мамандану',
    specMgmtSpecializationsPh: 'Мысалы: терапия, кардиология',
    specMgmtLanguages: 'Тілдерді білу',
    specMgmtLanguagesPh: 'Мысалы: қазақ, орыс, ағылшын',
    specMgmtReviewsLink: 'Дәрігер туралы пікірлерге сілтеме',
    specMgmtReviewFormLink: 'Дәрігерге пікір қалдыру формасының сілтемесі',
    specMgmtDegree: 'Дәрежесі',
    specMgmtExperience: 'Жұмыс өтілі',
    specMgmtModalEdit: 'Маманды өңдеу',
    specMgmtModalNew: 'Жаңа маман',
    specMgmtErrorLoad: 'Мамандар тізімін жүктеу мүмкін болмады',
    specMgmtUpdated: 'Маман туралы ақпарат жаңартылды',
    specMgmtAdded: 'Маман сәтті қосылды',
    specMgmtErrorSave: 'Маманды сақтау мүмкін болмады',
    specMgmtPhotoFormatError: 'Тек JPG және PNG қолдау көрсетіледі',
    specMgmtPhotoSizeError: 'Фото өлшемі {mb} МБ-дан аспауы керек',
    specMgmtPhotoUploaded: 'Фото сәтті жүктелді',
    specMgmtPhotoUploadError: 'Фотоны жүктеу мүмкін болмады',
    specMgmtDeleted: 'Маман жойылды',
    specMgmtErrorDelete: 'Маманды жою мүмкін болмады',
    specMgmtExcelOnly: 'Тек Excel файлдары (.xlsx, .xls) қолдау көрсетіледі',
    specMgmtExcelError: 'Excel файлын өңдеу мүмкін болмады',
    specMgmtConfirmDelete: 'Маманды жоюды растайсыз ба?',
    specMgmtConfirmDeleteDesc: 'Бұл әрекетті қайтаруға болмайды',
    specMgmtColSpecialist: 'Маман',
    specMgmtColCategory: 'Санаты',
    specMgmtColExperience: 'Өтілі',
    specMgmtYears: 'жыл',
    specMgmtColContacts: 'Байланыстар',
    specMgmtColDepartment: 'Бөлім',
    specMgmtColStatus: 'Мәртебе',

    // Admin settings
    adminSettingsTitle: 'Параметрлер',
    adminSettingsShowBrackets: 'Қызметтер бетінде жақшадағы мәтінді көрсету',
    adminSettingsShowBracketsExample: 'Мысалы: "Акушер гинеколог (отд вед беремен)".',
    adminSettingsBracketsOn: 'Жақшадағы мәтінді көрсету қосылды',
    adminSettingsBracketsOff: 'Жақшадағы мәтін жасырын',

    // AdmissionDate widget
    admDateToday: 'Бүгін',
    admDateTomorrow: 'Ертең',
    admDateMorning: 'Таңертең',
    admDateAfternoon: 'Күндіз',
    admDateEvening: 'Кеш',
    admDateNext: 'Келесі',
    admDateSelectDate: 'Күнді таңдаңыз',

    // Doctor widget
    doctorTodayWord: 'бүгін',
    doctorTomorrowWord: 'ертең',
    doctorSlotTitle: 'Жақын бос слоттар',
    doctorNoSlots: 'Қолжетімді бос уақыт слоттары жоқ',
    doctorChooseTime: 'Уақытты таңдаңыз',
    doctorBioMore: 'Толығырақ',
    doctorFilteringText: 'Бос слоттары бар дәрігерлер іріктелуде...',
    doctorSearchingText: 'Дәрігерлерді іздеу жүріп жатыр',
    doctorCategoryAll: 'Барлығы',
    doctorCategoryAdult: 'Ересектер',
    doctorCategoryChild: 'Балалар',

    // Footer
    footerBrandTop: 'University',
    footerBrandMain: 'Medical Center',
    footerBrandSub: 'Ғылым · Білім · Денсаулық сақтау',
    footerClinic: 'Клиника',
    footerClinicSite: 'Біздің сайт',
    footerClinicAbout: 'UMC туралы',
    footerClinicSpecialists: 'Біздің мамандар',
    footerPatients: 'Науқастарға',
    footerPatientsServices: 'Қызметтер мен құны',
    footerPatientsHospitalization: 'Госпитализация',
    footerPatientsReminder: 'Науқастарға арналған жадынама',
    footerContacts: 'Байланыс',
    footerContactsReach: 'Бізбен байланысу',
    footerContactsBooking: 'Қабылдауға жазылу',
    footerPolicy: 'Пайдаланушы келісімі',
    authCopyright: 'Барлық құқықтар қорғалған.'
  },
  en: {
    // Auth page
    title: 'Appointment Booking',
    subtitle: 'Enter IIN',
    iinPlaceholder: 'IIN',
    continueButton: 'Continue',
    errorMessage: 'An error occurred while getting the token',
    requiredField: 'Required field',
    iinLengthError: 'IIN must contain 12 digits',
    authBrandHeading: 'Book an Appointment',
    authBrandSub: 'Fast access to specialists,\nno queues, anytime.',
    authBrandFeature1: 'Choose a convenient date and time',
    authBrandFeature2: 'No registration — IIN only',
    authBrandFeature3: 'Secure data processing',
    authCardDesc: 'Enter your IIN to access the appointment booking.',
    authIinHint: '12 digits, no spaces or hyphens',
    authPrivacyText: 'By clicking "Continue" you agree to the',
    
    // Service page
    serviceTitle: 'Service Selection',
    serviceInstruction: 'Select a service to book an appointment',
    serviceSearchPlaceholder: 'Search by service',
    paymentMethodTitle: 'Payment method',
    paidServices: 'Paid',
    freeServices: 'By insurance (OSMS)',

    // AI helper
    aiHelperTitle: 'Not sure which doctor you need?',
    aiHelperSubtitle: 'Briefly describe your symptoms — we will suggest the most relevant service.',
    aiHelperPlaceholder: 'For example: severe headache for three days, fever 38, ringing in the ears',
    aiHelperButton: 'Suggest a service',
    aiHelperLoading: 'Looking for the most relevant service...',
    aiHelperResultTitle: 'Recommended services',
    aiHelperNoMatch: 'No suitable service found. Try describing your symptoms in more detail or use the search.',
    aiHelperUrgent: 'Attention: this may be an emergency',
    aiHelperDisclaimer: 'This suggestion is informational and does not replace consultation with a doctor.',
    aiHelperError: 'Could not get a recommendation. Please try again later.',
    aiHelperUnavailable: 'The recommendation service is temporarily unavailable.',
    aiHelperBadge: 'Recommended',
    aiHelperClear: 'Clear',

    osmsTitle: 'For booking under GOBMP/OCMS',
    osmsMessage: 'Please call the numbers below or leave a request, and the operator will call you back.',
    
    // Doctor page
    doctorTitle: 'Doctor Selection',
    doctorSearchPlaceholder: 'Search by name',
    
    // Doctor card
    reviews: 'Reviews',
    reviewsCount: 'reviews',
    noReviews: 'No reviews yet',
    degree: 'Degree',
    about: 'About',
    position: 'Position',
    cost: 'Cost',
    bookAppointment: 'Book',
    closeReviews: 'Close',
    doctorReviews: 'Doctor reviews',
    doctorCopyLink: 'Copy link',
    doctorLinkCopied: 'Doctor link copied',

    // Form page
    formTitle: 'Booking',
    selectedService: 'Selected service',
    selectedDoctor: 'Selected doctor',
    doctorType: 'Doctor type',
    experience: 'Service cost',
    appointmentDateTime: 'Appointment date and time',
    appointmentDateTimePlaceholder: 'Appointment date and time',
    yourIIN: 'Your IIN',
    fullName: 'Full name (who will come)',
    fullNamePlaceholder: 'Full name (who will come)',
    phoneHint: 'Enter phone number',
    phonePlaceholder: '+7 (___) ___ __-__',
    privacyPolicy: 'privacy policy',
    privacyAgreement: 'I accept the privacy policy and give consent to the processing of my personal data',
    smsAgreement: 'I confirm my consent to receive SMS and e-mail notifications',
    directionAgreement: 'I confirm that a referral is required for booking under GOBMP/OCMS',
    
    // Schedule page
    scheduleTitle: 'Thank you for booking!',
    scheduleSubtitle: 'Your appointment has been successfully registered.',
    doctor: 'Doctor:',
    service: 'Service:',
    dateTime: 'Date and time:',
    callMessage: 'Wait for a call to confirm your appointment.',
    missingInfo: 'Appointment information is missing',
    ratingTitle: 'Rate your online booking experience',
    ratingSubtitle: 'Please rate how convenient it was to book your appointment.',
    ratingCommentPlaceholder: 'Comment (optional)',
    ratingSubmit: 'Submit feedback',
    ratingThanksTitle: 'Thank you for your rating!',
    ratingThanksSubtitle: 'Your feedback helps us improve.',
    
    // Navigation
    step1: 'Service Selection',
    step2: 'Doctor Selection',
    step3: 'Booking',
    
    // Policy page
    policyTitle: 'Privacy Policy',
    backButton: '← Back',
    back: 'Back',
    generalProvisions: '1. General Provisions',
    dataCollection: '2. Personal Data Collection',
    dataPurpose: '3. Purpose of Personal Data Processing',
    legalBasis: '4. Legal Basis for Processing',
    dataRetention: '5. Data Retention Periods',
    dataSecurity: '6. Data Security',
    dataSharing: '7. Data Sharing with Third Parties',
    yourRights: '8. Your Rights',
    policyChanges: '9. Policy Changes',
    lastUpdated: 'Last updated:',
    documentSubtitle: 'University Medical Clinic (UMC)',
    version: 'Version',
    
    // Policy content translations
    scopeOfApplication: '1.1. Scope of Application',
    policyDefinition: 'This Privacy Policy (hereinafter — "Policy") defines the procedure for processing personal data of users of the UMC online appointment booking system (hereinafter — "System", "Service").',
    acceptanceOfTerms: '1.2. Acceptance of Terms',
    acceptanceText: 'By using the System, you agree to the terms of this Policy. If you do not agree with any terms, please do not use the System.',
    dataCategories: '2.1. Categories of Data Collected',
    weCollect: 'We collect the following personal data:',
    iinDescription: 'Individual Identification Number (IIN) — used to identify the user in the system',
    nameDescription: 'First and last name — for personalization of services and communication with the patient',
    phoneDescription: 'Phone number — for sending notifications and confirmations',
    medicalInfoDescription: 'Medical services information — data about selected services and doctors',
    appointmentDataDescription: 'Appointment data — time, date and details of scheduled visits',
    processingPurposes: '3.1. Main Processing Purposes',
    personalDataProcessed: 'Personal data is processed for the following purposes:',
    systemOperation: 'System operation — support for online booking functionality',
    appointmentManagement: 'Appointment management — creation and management of appointments',
    notifications: 'Notifications — sending SMS and email notifications',
    serviceImprovement: 'Service improvement — analysis and improvement of service quality',
    legalCompliance: 'Legal compliance — fulfillment of legal requirements',
    processingBasis: '4.1. Processing Basis',
    processingBasisText: 'Personal data processing is carried out on the basis of:',
    subjectConsent: 'Subject consent — your explicit consent to the processing of personal data',
    contractExecution: 'Contract execution — necessity for providing medical services',
    legalRequirements: 'Legal requirements — compliance with the laws of the Republic of Kazakhstan',
    retentionPeriods: '5.1. Retention Periods',
    retentionText: 'Personal data is stored for the period necessary to achieve the processing purposes, as well as within the periods established by the legislation of the Republic of Kazakhstan.',
    activeRecords: 'Active records — stored until completion of the treatment course',
    treatmentHistory: 'Treatment history — stored in accordance with medical standards',
    userAccount: 'User account — stored until consent is withdrawn or deletion',
    securityMeasures: '6.1. Security Measures',
    securityText: 'We take necessary technical and organizational measures to protect personal data from unauthorized access, alteration, disclosure or destruction.',
    appliedMeasures: 'Applied security measures include:',
    dataEncryption: 'Data encryption during transmission and storage',
    accessControl: 'Access control to personal data',
    securityMonitoring: 'Regular security monitoring',
    systemUpdates: 'Security system updates',
    staffTraining: 'Staff training on security issues',
    transferConditions: '7.1. Transfer Conditions',
    transferText: 'Personal data may be transferred to third parties only in cases provided for by law, or with your explicit consent.',
    medicalInstitutions: 'Medical institutions — only when necessary to provide medical assistance',
    governmentBodies: 'Government bodies — in cases provided for by law',
    otherCases: 'Other cases — only with your explicit consent',
    dataSubjectRights: '8.1. Your Rights as a Data Subject',
    youHaveRight: 'You have the right to:',
    rightToInfo: 'Right to information — receive information about the processing of your personal data',
    rightToCorrection: 'Right to correction — require clarification, blocking or destruction of data',
    rightToWithdraw: 'Right to withdraw — withdraw consent to data processing',
    rightToAppeal: 'Right to appeal — appeal to the authorized body for personal data protection',
    changesProcedure: '9.1. Procedure for Making Changes',
    changesText: 'We reserve the right to make changes to this Policy. Changes will be notified through the System or by email.',
    whenMakingChanges: 'When making changes:',
    usersReceiveNotifications: 'Users receive notifications about changes',
    effectiveDateIndicated: 'The effective date of changes is indicated',
    continuedUseMeansAgreement: 'Continued use means agreement with new terms',
    
    // Error messages
    appointmentError: 'Error creating appointment',
    unknownError: 'Unknown error',
    alreadyBookedWarning: 'Warning',
    alreadyBookedTitle: 'You are already booked in this department for the current week',
    alreadyBookedMessage: 'Please try to book for next week — the system allows only one appointment per week',
    
    // Common
    kzt: 'KZT',
    tenge: '₸',
    okButton: 'OK',
    fromPrice: 'from',
    goToServiceSelection: 'Go to service selection',
    userDataError: 'Error: user data not found',
    formDoctorLoadError: 'Failed to load doctor data',

    // Common buttons
    saveButton: 'Save',
    cancelButton: 'Cancel',
    deleteButton: 'Delete',
    addButton: 'Add',
    editButton: 'Edit',
    resetButton: 'Reset',

    // Form placeholders
    formServicePlaceholder: 'Select a service',
    formDoctorPlaceholder: 'Select a specialist',
    formTimePlaceholder: 'Select time',
    formNoTimeAvailable: 'No available time, please choose another specialist',

    // Admin layout / sidebar
    adminPanelTitle: 'UMC Admin Panel',
    adminLogout: 'Log out',
    adminNavServices: 'Services Management',
    adminNavUploadHistory: 'Services Upload History',
    adminNavClients: 'Clients & Appointments',
    adminNavSpecialists: 'Specialists',
    adminNavStatistics: 'Statistics',
    adminNavSettings: 'Settings',
    adminNavRatings: 'Booking Ratings',
    adminRatingsTitle: 'Online Booking Convenience Ratings',
    adminRatingsSubtitle: 'How patients rate the convenience of booking an appointment',
    adminRatingsRefresh: 'Refresh',
    adminRatingsEmpty: 'No ratings yet',
    adminRatingsLoadError: 'Failed to load ratings',
    adminRatingsAverage: 'Average rating',
    adminRatingsTotal: 'Total ratings',
    adminRatingsColDate: 'Date',
    adminRatingsColRating: 'Rating',
    adminRatingsColDoctor: 'Doctor (ID)',
    adminRatingsColService: 'Service',
    adminRatingsColIin: 'IIN',

    adminUploadHistoryTitle: 'Services Upload History',
    adminUploadHistorySubtitle: 'Audit log of every Excel upload: who refreshed the services catalog, when, and with what result.',
    adminUploadHistoryRefresh: 'Refresh',
    adminUploadHistoryDate: 'Date',
    adminUploadHistoryUser: 'User',
    adminUploadHistoryFile: 'File',
    adminUploadHistorySize: 'Size',
    adminUploadHistoryStatus: 'Status',
    adminUploadHistoryStatusSuccess: 'Success',
    adminUploadHistoryStatusFailed: 'Failed',
    adminUploadHistoryTotal: 'Total',
    adminUploadHistoryEmpty: 'History is empty',
    adminUploadHistoryLoadError: 'Failed to load history',

    adminDashExportHeading: 'Export current services list',
    adminDashExportDescription: 'Download the current services catalog as Excel. The file structure mirrors the upload format (3 sheets: RU/KK/EN, 9 columns), so it can be edited and re-uploaded.',
    adminDashExportButton: 'Download Excel',
    adminDashExportingButton: 'Preparing file...',
    adminDashExportSuccess: '✅ File downloaded',
    adminDashExportError: 'Failed to export file',

    // Admin login
    adminLoginTitle: 'Sign in',
    adminLoginSubtitle: 'Services management panel',
    adminLoginPhonePlaceholder: '+7 (___) ___ __-__',
    adminLoginPhoneRequired: 'Enter phone number',
    adminLoginPhoneInvalid: 'Invalid phone format',
    adminLoginPassword: 'Password',
    adminLoginPasswordRequired: 'Enter password',
    adminLoginSubmit: 'Sign in',
    adminLoginFooter: 'UMC Services Management System',
    adminLoginSuccess: 'Successfully signed in',
    adminLoginErrorGeneric: 'Sign-in error',
    adminLoginErrorServer: 'Server connection error',

    // Admin dashboard
    adminDashTitle: 'Services Management',
    adminDashSubtitle: 'Upload an Excel file to fully refresh the services list in the database. All existing data will be deleted and replaced.',
    adminDashUploadHeading: 'Upload and update services',
    adminDashSelectFile: 'Select Excel file',
    adminDashSupportedFormats: 'Supported formats: .xlsx, .xls',
    adminDashMaxFileSize: 'Maximum file size: 10MB',
    adminDashFileStructureTitle: 'Multilingual Excel file structure:',
    adminDashFileStructureSheets: 'The file must contain 3 sheets (pages):',
    adminDashSheet1: 'Sheet 1: Russian',
    adminDashSheet2: 'Sheet 2: Kazakh',
    adminDashSheet3: 'Sheet 3: English',
    adminDashColumnStructure: 'Column layout for each sheet:',
    adminDashColumnsAC: 'A: ID | B: Department ID | C: Department name',
    adminDashColumnsDF: 'D: Doctor ID | E: Doctor name | F: Service ID',
    adminDashColumnsGI: 'G: Service name | H: Payment type | I: Price',
    adminDashUploadButton: 'Upload and update all services',
    adminDashUploadingButton: 'Updating...',
    adminDashErrorExcelOnly: '❌ Error: Only Excel files (.xlsx, .xls) can be uploaded!',
    adminDashErrorSize: '❌ Error: File must be smaller than 10MB!',
    adminDashErrorSelect: '❌ Please select an Excel file to upload',
    adminDashSuccessHeader: '✅ File processed successfully!',
    adminDashSuccessUpdated: 'Updated',
    adminDashSuccessUpdatedSuffix: 'services.',
    adminDashSuccessRu: '• Russian:',
    adminDashSuccessKk: '• Kazakh:',
    adminDashSuccessEn: '• English:',
    adminDashSuccessRecordsWord: 'records',
    adminDashErrorUpload: 'Error uploading file',

    // Statistics dashboard
    statsTitle: 'System statistics',
    statsEventFilter: 'Event type',
    statsEventIin: 'IIN entry attempts',
    statsEventAuthSuccess: 'Successful sign-ins',
    statsEventApptCreated: 'Created appointments',
    statsEventServices: 'Selected services',
    statsEventDoctors: 'Selected doctors',
    statsExportButton: 'Export CSV',
    statsExportSuccess: 'Data exported successfully',
    statsExportError: 'Error exporting data',
    statsErrorLoad: 'Error loading statistics',
    statsErrorLoadDaily: 'Error loading daily statistics',
    statsErrorLoadHourly: 'Error loading hourly statistics',
    statsCardIinAttempts: 'IIN entry attempts',
    statsCardAuthSuccess: 'Successful sign-ins',
    statsCardApptCreated: 'Created appointments',
    statsCardUnique: 'Unique users',
    statsTabDaily: 'Daily statistics',
    statsTabHourly: 'Hourly statistics',
    statsTabPopular: 'Popular services',
    statsTabLangs: 'Language distribution',
    statsDailyTitle: 'Daily statistics table',
    statsHourlyTitle: 'Hourly statistics table',
    statsHourlySelectDate: 'Select date',
    statsPopularServicesTitle: 'Popular services',
    statsLangDistributionTitle: 'Language distribution',
    statsColDate: 'Date',
    statsColEventType: 'Event type',
    statsColCount: 'Count',
    statsColUnique: 'Unique users',
    statsColHour: 'Hour',
    statsColService: 'Service',
    statsColLang: 'Language',
    statsColPercent: 'Percent',

    // Clients analytics
    clientsTitle: 'Clients and appointments analytics',
    clientsErrorLoad: 'Error loading data',
    clientsStatTotal: 'Total clients',
    clientsStatBooked: 'Booked',
    clientsStatIinOnly: 'IIN only',
    clientsStatConversion: 'Conversion',
    clientsStatTotalAppts: 'Total appointments',
    clientsStatLast30: 'Last 30 days',
    clientsStatPopDoctors: 'Popular doctors',
    clientsStatPopServices: 'Popular services',
    clientsTabClients: 'Clients',
    clientsTabAppointments: 'Appointments',
    clientsTabPopDoctors: 'Popular doctors',
    clientsTabPopServices: 'Popular services',
    clientsStatusFilter: 'Status filter:',
    clientsFilterAll: 'All',
    clientsFilterIin: 'IIN only',
    clientsFilterBooked: 'Booked',
    clientsStatusBooked: 'Booked',
    clientsStatusIinOnly: 'IIN only',
    clientsColIin: 'IIN',
    clientsColName: 'Full name',
    clientsColPhone: 'Phone',
    clientsColStatus: 'Status',
    clientsColLang: 'Language',
    clientsColCreated: 'Created date',
    clientsColApptId: 'ID',
    clientsColApptClient: 'Client',
    clientsColApptDoctor: 'Doctor',
    clientsColApptService: 'Service',
    clientsColApptDate: 'Appointment date',
    clientsColApptCreated: 'Created',
    clientsColDoctorId: 'Doctor ID',
    clientsColApptCount: 'Appointment count',
    clientsColUnique: 'Unique clients',
    clientsColServiceId: 'Service ID',
    langLabelRu: 'Russian',
    langLabelKk: 'Kazakh',
    langLabelEn: 'English',

    // Specialists management
    specMgmtTitle: 'Specialists',
    specMgmtSearchPlaceholder: 'Search: full name, specialization, specializations (RU), category, IIN, phone…',
    specMgmtFilterSpecAll: 'All specializations',
    specMgmtFilterCatAll: 'All categories',
    specMgmtFilterCatChild: 'Pediatric',
    specMgmtFilterCatAdult: 'Adult',
    specMgmtSortRecent: 'Recently changed first',
    specMgmtSortOldest: 'Oldest first',
    specMgmtSortNameAsc: 'By name (A → Z)',
    specMgmtSortNameDesc: 'By name (Z → A)',
    specMgmtSortSpecAsc: 'By specialization (A → Z)',
    specMgmtSortSpecDesc: 'By specialization (Z → A)',
    specMgmtSortExpDesc: 'By experience (most first)',
    specMgmtSortExpAsc: 'By experience (least first)',
    specMgmtImportExcel: 'Import Excel',
    specMgmtExportExcel: 'Export Excel',
    specMgmtExportSuccess: '✅ Specialists list downloaded',
    specMgmtExportError: 'Failed to export specialists list',
    specMgmtAddBtn: 'Add specialist',
    specMgmtFoundLabel: 'Found:',
    specMgmtFoundOf: 'of',
    specMgmtTotalLabel: 'Total:',
    specMgmtTabGeneral: 'General',
    specMgmtTabContacts: 'Contacts & schedule',
    specMgmtTabRussian: 'Russian',
    specMgmtTabKazakh: 'Kazakh',
    specMgmtTabEnglish: 'English',
    specMgmtSectionBasic: 'Basic (TS 2.1)',
    specMgmtSectionBio: 'Description and biography',
    specMgmtSectionPhoto: 'Photo',
    specMgmtSectionContacts: 'Contact information',
    specMgmtSectionSchedule: 'Work schedule',
    specMgmtFinalFio: 'Final display name:',
    specMgmtFinalFioSource: '(from Russian block or field below)',
    specMgmtFinalFioMissing: '— set last name, first name, patronymic (RU) or enter full name manually',
    specMgmtFullNameManual: 'Full name (manual, optional)',
    specMgmtFullNameManualHint: 'If empty — Last name, First name, Patronymic from the "Russian" tab',
    specMgmtFullNamePh: 'E.g.: Ivanov Ivan Ivanovich',
    specMgmtBriefSpecLabel: 'Brief specialization (internal, optional)',
    specMgmtBriefSpecHint: 'If empty — "Specialty" (RU) or first item from "Specialization" (RU) split by ","',
    specMgmtBriefSpecPh: 'Cardiologist',
    specMgmtFieldCategory: 'Category',
    specMgmtCategorySelect: 'Select category',
    specMgmtCategoryChild: 'Pediatric',
    specMgmtCategoryAdult: 'Adult',
    specMgmtCategoryPh: 'Pediatric / adult',
    specMgmtFieldIin: 'IIN',
    specMgmtFieldIinHint: 'Duplicated in multilingual settings if needed — primary storage is here',
    specMgmtExpYears: 'Experience (full years)',
    specMgmtFieldStatus: 'Status',
    specMgmtStatusHint: 'Active / inactive',
    specMgmtStatusActive: 'Active',
    specMgmtStatusInactive: 'Inactive',
    specMgmtAboutDoctor: 'About (doctor)',
    specMgmtAboutDoctorPh: 'Text for the doctor card',
    specMgmtEducation: 'Education',
    specMgmtEducationPh: 'University, residency, courses',
    specMgmtBiography: 'Biography',
    specMgmtBiographyPh: 'Brief professional biography',
    specMgmtPhotoLoading: 'Uploading photo',
    specMgmtPhotoLoadingPlease: 'Please wait',
    specMgmtPhotoUploading: 'Uploading…',
    specMgmtPhotoUpload: 'Upload photo',
    specMgmtPhotoDelete: 'Delete',
    specMgmtPhotoHint: 'JPG/PNG, up to 5 MB',
    specMgmtPhone: 'Phone',
    specMgmtPhonePh: '+7 (777) 777-77-77',
    specMgmtEmail: 'E-mail',
    specMgmtEmailInvalid: 'Invalid e-mail',
    specMgmtEmailPh: 'doctor@example.com',
    specMgmtAdditionalContacts: 'Additional contacts',
    specMgmtSchedulePh: 'Mon-Fri: 09:00 – 18:00\nSat: 10:00 – 14:00',
    specMgmtMultiValuesHint: 'Multiple values separated by ","',
    specMgmtFioRequiredAlert: 'Required: enter full name manually on the "General" tab, or last and first name (and patronymic if needed) below',
    specMgmtSpecRequiredAlert: 'Required: specify "Specialty" (RU), or "Specialization" (RU) separated by comma, or a brief specialization on the "General" tab',
    specMgmtLastName: 'Last name',
    specMgmtLastNameHelp: 'Together with first/middle name forms the required full name unless one was entered manually on "General"',
    specMgmtFirstName: 'First name',
    specMgmtPatronymic: 'Patronymic',
    specMgmtCenters: 'Centers',
    specMgmtKads: 'KADs',
    specMgmtDepartment: 'Department',
    specMgmtSpecialty: 'Specialty',
    specMgmtSpecialtyHelp: 'Together with the "Specialization" list, populates the required "specialization" field for the API',
    specMgmtSpecializations: 'Specialization',
    specMgmtSpecializationsPh: 'E.g.: therapy, cardiology',
    specMgmtLanguages: 'Languages',
    specMgmtLanguagesPh: 'E.g.: kk, ru, en',
    specMgmtReviewsLink: 'Doctor reviews link',
    specMgmtReviewFormLink: 'Doctor review form link',
    specMgmtDegree: 'Degree',
    specMgmtExperience: 'Work experience',
    specMgmtModalEdit: 'Edit specialist',
    specMgmtModalNew: 'New specialist',
    specMgmtErrorLoad: 'Failed to load specialists list',
    specMgmtUpdated: 'Specialist information updated',
    specMgmtAdded: 'Specialist successfully added',
    specMgmtErrorSave: 'Failed to save specialist',
    specMgmtPhotoFormatError: 'Only JPG and PNG are supported',
    specMgmtPhotoSizeError: 'Photo size must not exceed {mb} MB',
    specMgmtPhotoUploaded: 'Photo uploaded successfully',
    specMgmtPhotoUploadError: 'Failed to upload photo',
    specMgmtDeleted: 'Specialist deleted',
    specMgmtErrorDelete: 'Failed to delete specialist',
    specMgmtExcelOnly: 'Only Excel files (.xlsx, .xls) are supported',
    specMgmtExcelError: 'Failed to process Excel file',
    specMgmtConfirmDelete: 'Delete specialist?',
    specMgmtConfirmDeleteDesc: 'This action cannot be undone',
    specMgmtColSpecialist: 'Specialist',
    specMgmtColCategory: 'Category',
    specMgmtColExperience: 'Experience',
    specMgmtYears: 'years',
    specMgmtColContacts: 'Contacts',
    specMgmtColDepartment: 'Department',
    specMgmtColStatus: 'Status',

    // Admin settings
    adminSettingsTitle: 'Settings',
    adminSettingsShowBrackets: 'Show bracket text on the services page',
    adminSettingsShowBracketsExample: 'For example: "Obstetrician-gynecologist (high-risk pregnancy)".',
    adminSettingsBracketsOn: 'Bracket text display enabled',
    adminSettingsBracketsOff: 'Bracket text hidden',

    // AdmissionDate widget
    admDateToday: 'Today',
    admDateTomorrow: 'Tomorrow',
    admDateMorning: 'Morning',
    admDateAfternoon: 'Afternoon',
    admDateEvening: 'Evening',
    admDateNext: 'Next',
    admDateSelectDate: 'Select date',

    // Doctor widget
    doctorTodayWord: 'today',
    doctorTomorrowWord: 'tomorrow',
    doctorSlotTitle: 'Nearest available slots',
    doctorNoSlots: 'No available time slots',
    doctorChooseTime: 'Choose time',
    doctorBioMore: 'Details',
    doctorFilteringText: 'Filtering doctors with available slots...',
    doctorSearchingText: 'Searching doctors...',
    doctorCategoryAll: 'All',
    doctorCategoryAdult: 'Adult',
    doctorCategoryChild: 'Pediatric',

    // Footer
    footerBrandTop: 'University',
    footerBrandMain: 'Medical Center',
    footerBrandSub: 'Science · Education · Healthcare',
    footerClinic: 'Clinic',
    footerClinicSite: 'Our website',
    footerClinicAbout: 'About UMC',
    footerClinicSpecialists: 'Our specialists',
    footerPatients: 'For patients',
    footerPatientsServices: 'Services and pricing',
    footerPatientsHospitalization: 'Hospitalization',
    footerPatientsReminder: 'Patient guidelines',
    footerContacts: 'Contacts',
    footerContactsReach: 'Contact us',
    footerContactsBooking: 'Book an appointment',
    footerPolicy: 'Terms of use',
    authCopyright: 'All rights reserved.'
  }
};

export type Language = keyof typeof translations; 